module.exports = __webpack_public_path__ + "img/banner5.4383fb35.png";